//* 부고 등록·수정 폼의 장지 입력 — 자유 입력 + 포커스하면 내 자주쓰는 장지를 추천한다
//* 빈칸이면 전부, 글자를 치면 포함 검색으로 좁힌다. 고르면 그 값으로 채워지고 목록은 닫힌다.
//* (기존 CemeteryBar: 모바일은 바텀시트 select + "직접입력" 2단계라 번잡해서 상주 말씀과 같은 형태로 교체)
import { FC, useMemo, useState } from 'react';

import { TextField } from '@shared/components/TextField';
import { useAuth } from '@shared/state/hooks/useAuth';
import { Control, UseFormRegister, UseFormSetValue, useWatch } from 'react-hook-form';

import { SuggestionDropdown, SuggestionItem } from '../../components/SuggestionDropdown';
import { readMyDetailList } from '../../utils/myDetailList.util';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValue: UseFormSetValue<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: UseFormRegister<any>;
  name: string;
  className?: string;
  placeholder?: string;
}

//* 빈 입력이면 전부, 아니면 포함 검색(공백·대소문자 무시). 입력값과 완전히 같은 것 하나뿐이면 굳이 안 띄운다
export const filterCemeterySuggestions = (
  myList: string[],
  input: string,
): SuggestionItem[] => {
  const q = input.replace(/\s+/g, '').toLowerCase();
  const matched = q
    ? myList.filter((c) => c.replace(/\s+/g, '').toLowerCase().includes(q))
    : myList;
  if (matched.length === 1 && matched[0]?.trim() === input.trim()) return [];
  return matched.map((text) => ({ key: `my-${text}`, text, mine: true }));
};

const CemeteryInput: FC<Props> = ({
  control,
  setValue,
  register,
  name,
  className = '',
  placeholder = '장지',
}) => {
  const { userProfile, bugoCamelRole } = useAuth();
  const camelRole = bugoCamelRole();
  const myList = useMemo(
    () => readMyDetailList(userProfile, camelRole, 'cemeteryList'),
    [userProfile, camelRole],
  );

  const currentText: string = useWatch({ control, name }) ?? '';
  const [focused, setFocused] = useState(false);
  const items = useMemo(
    () => (focused ? filterCemeterySuggestions(myList, currentText) : []),
    [focused, myList, currentText],
  );

  const { onBlur: registerOnBlur, ...field } = register(name);

  return (
    <TextField
      type="text"
      autoComplete="off"
      placeholder={placeholder}
      className={className}
      onFocus={() => setFocused(true)}
      {...field}
      onBlur={(e) => {
        setFocused(false);
        registerOnBlur(e);
      }}
    >
      {items.length > 0 && (
        <SuggestionDropdown
          title="자주쓰는 장지"
          items={items}
          onPick={(text) => setValue(name, text, { shouldDirty: true })}
          manageTo="/user/prefer/cemetery"
          manageLabel="내 장지 관리"
          scrollClassName="max-h-56 overflow-y-auto"
        />
      )}
    </TextField>
  );
};

export default CemeteryInput;
